// MUI styled components
import { styled } from "@mui/material/styles";

import {
  Box,
  TextField,
  Grid,
  Stack,
  Toolbar,
  AppBar,
  Typography,
} from "@mui/material";
import borderSvg from "../images/gradient-border_l.png";

// global styles
export const PageTitleTypography = styled(Typography)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  [theme.breakpoints.up("md")]: {
    justifyContent: "left",
  },
}));

export const GlassMorphicContainer = styled(Box)(({ theme }) => ({
  background:
    "linear-gradient(121.05deg, rgba(222, 254, 255, 0.2496) 7.19%, rgba(206, 254, 255, 0.0806) 30%, rgba(206, 254, 255, 0.0494) 67.05%, rgba(206, 254, 255, 0.1794) 85.38%)",
  borderRadius: 16,
  border: "1px solid rgba(255, 255, 255, 0.1)",
  borderImage:
    "linear-gradient(225deg, rgba(219, 228, 231, 0.5) 0%, rgba(219, 228, 231, 0) 35%, rgba(221, 225, 255, 0) 64%, rgba(221, 225, 255, 1) 100%)",
  width: "calc(100% - 24px)",
  padding: 12,
  backdropFilter: "blur(20px)",
  [theme.breakpoints.up("md")]: {
    width: "calc(100% - 96px)",
    padding: 48,
  },
}));

export const StyledTextField = styled(TextField)({
  width: "100%",
  borderColor: "white",
  borderWidth: 1,
  color: "white",
  "& .MuiInputBase-root:before": {
    borderBottom: "1px solid white",
    color: "white",
  },
  "& .MuiInputBase-root:hover": {
    borderBottom: 0,
    color: "white",
  },
  "& .MuiInputBase-root-MuiInput-root:hover": {
    borderBottom: "1px solid white",
    color: "white",
  },
  "& .MuiInputBase-input": {
    color: "white",
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255, 255, 255, 0.6)",
  },
});

export const Box1400 = styled(Box)(({ theme }) => ({
  width: "calc(100% - 32px)",
  padding: "0 16px",
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  zIndex: 30,
  [theme.breakpoints.up("xl")]: {
    maxWidth: 1400,
    padding: 0,
  },
}));

export const GradientLineBox = styled(Box)(({ theme }) => ({
  background: `url(${borderSvg})`,
  backdropFilter: "blur(10px)",
  width: "100%",
  maxWidth: 500,
  backgroundSize: "100% 100%",
  margin: "0 auto",
}));

export const GetInTouchBox = styled(Box)(({ theme }) => ({
  border: "2px solid transparent",
  borderImage:
    "linear-gradient(155.88deg, #436CFF 26.91%, #FFFEC1 49.65%, #98FAFD 78.64%) 20 stretch",
  boxSizing: "border-box",
  backdropFilter: "blur(10px)",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  padding: 3,
}));
export const MapBox = styled(Box)(({ theme }) => ({
  height: "100%",
  minHeight: 200,
}));

// Header
export const StyledToolBar = styled(Toolbar)(({ theme }) => ({
  maxWidth: 1400,
  justifyContent: "space-between",
  width: "100%",
}));

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "center",
  left: "0 !important",
  maxWidth: "100vw",
}));

// Footer
export const StyledFooterWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  width: "100vw",
  height: 180,
  zIndex: 20,
  position: "relative",
  display: "flex",
  alignItems: "center",
}));

export const FooterRightWrapper = styled(Stack)(({ theme }) => ({
  justifyContent: "end",
  alignItems: "flex-end",
  height: "100%",
}));

export const FeatureCard = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: 24,
  color: theme.palette.common.white,
  zIndex: 30,
  position: "relative",
  borderRadius: 12,
  [theme.breakpoints.up("sm")]: {
    padding: 24,
  },
  [theme.breakpoints.up("xl")]: {
    padding: "24px 48px",
  },
}));

export const FeaturesContainer = styled(Box)(({ theme }) => ({
  width: "100vw",
  position: "relative",
  zIndex: 20,
  maxWidth: 1400,
  display: "flex",
  justifyContent: "center",
  [theme.breakpoints.up("sm")]: {
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

export const FeatureCardContainer = styled(Grid)(({ theme }) => ({
  width: "inherit",
  [theme.breakpoints.up("sm")]: {
    width: "calc(100% + 24px)",
  },
}));

export const LogoContainer = styled(Stack)(({ theme }) => ({
  position: "absolute",
  top: 150,
  left: "50%",
  transform: "translate(-50%, 0%)",
  width: "calc(100% - 32px)",
  zIndex: 10,
  height: 380,
  justifyContent: "space-between",
  alignItems: "center",
  [theme.breakpoints.up("sm")]: {
    width: 500,
    top: 200,
  },
}));

// Homepage
export const TrustedByContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "0 16px",
  [theme.breakpoints.up("sm")]: {
    margin: "0 auto",
    maxWidth: 1400,
  },
}));

export const TrustedByGridContainer = styled(Grid)(({ theme }) => ({
  marginTop: 20,
  [theme.breakpoints.up("md")]: {
    justifyContent: "center",
  },
}));
export const TrustedByGridItem = styled(Grid)(({ theme }) => ({
  paddingLeft: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

// About page
export const MemberNameBox = styled(Stack)(({ theme }) => ({
  position: "absolute",
  zIndex: 35,
  left: "50%",
  bottom: 50,
  translate: "-50% 0%",
  alignItems: "center",
  width: "100%",
}));

export const MemberGridContainer = styled(Grid)(({ theme }) => ({
  justifyContent: "center",
  [theme.breakpoints.up("md")]: {
    justifyContent: "start",
  },
}));

export const teamMemberImgStyles = {
  borderRadius: "50%",
  width: "100%",
  height: "100%",
};

export const PartnersGridItem = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
}));

export const CEOGridItem = styled(Grid)(({ theme }) => ({
  padding: 48,
  display: "flex",
  justifyContent: "center",
  [theme.breakpoints.up("md")]: {
    paddingLeft: 24,
    paddingTop: 24,
    paddingRight: 0,
    paddingBottom: 0,
  },
}));

export const CEOcaptionStyle = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: "80%",
  left: "50%",
  zIndex: 300,
  translate: "-50% 0%",
}));

//Services page
export const QuoteText = styled(Typography)(({ theme }) => ({
  margin: "auto",
  width: "calc(100% - 24px)",
  [theme.breakpoints.up("md")]: {
    width: "calc(100% - 48px)",
  },
  [theme.breakpoints.up("lg")]: {
    width: "calc(100% - 160px)",
  },
}));
export const ListServicesGridContainer = styled(Grid)(({ theme }) => ({
  justifyContent: "center",
}));
export const TestimonialLeftTexts = styled(Stack)(({ theme }) => ({
  height: "100%",
  justifyContent: "center",
  alignItems: "center ",
}));

// Contacts page
export const ContactsWrapper = styled(Stack)(({ theme }) => ({
  justifyContent: "space-between",
  height: 300,
  [theme.breakpoints.up("md")]: {
    height: "100%",
  },
}));

export const SocialLinksContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "left",
  flexWrap: "wrap",
  height: "fit-content",
  [theme.breakpoints.up("md")]: {
    justifyContent: "space-between",
  },
}));

export const ContactsGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
}));

export const ThankYouBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  minHeight: 200,
}));
